import { typeToIcon } from '@/modules/content/config';

/*
 * @param {SearcherResult} content
 * @return {SelectableListItem}
 */
export function SearcherSelectionItemMapper({ entity }) {
  const badges = [];
  if (entity.processing) {
    badges.push({
      color: 'warning',
      label: 'message.content.status.processing',
    });
  } else if (entity.scheduled) {
    badges.push({
      color: 'orange',
      fontColor: 'white',
      label: 'message.content.editor.scheduled',
    });
  } else if (entity.published) {
    badges.push({
      label: 'message.metadata.published',
    });
  } else {
    badges.push({
      label: 'message.metadata.draft',
    });
  }

  return {
    id: entity.id,
    type: `message.content.type.${entity.type}`,
    icon: typeToIcon(entity.type),
    title: entity.title,
    entity,
    thumbnailUrl: entity.largeThumbnailUrl || entity.thumbnailUrl,
    badges,
  };
}

export default {
  SearcherSelectionItemMapper,
};
